/* eslint-disable one-var-declaration-per-line */
/* eslint-disable one-var */
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import { getStatisticsEmails } from 'actions/statistics/emails';

import RangeDates from './RangeDates';
import Charts from './Charts';

function getPercentFixed(amount, total) {
    return amount && total ? (amount / total * 100).toFixed(2) : 0;
}

class StatisticsEmailsPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            from: moment().add(-1, 'w').startOf('day').toDate(),
            until: moment().startOf('day').toDate(),
            showNormalized: false,
        };

        this.changeDateRange = this.changeDateRange.bind(this);
        this.handleNormalize = this.handleNormalize.bind(this);
    }

    changeDateRange(from, until) {
        this.setState({
            from,
            until,
        });
    }

    UNSAFE_componentWillMount() {
        const { from, until } = this.state;

        this.props.getStatisticsEmails(
            moment(from).utcOffset(0, true).valueOf(),
            moment(until).utcOffset(0, true).valueOf(),
        );
    }

    handleNormalize() {
        this.setState({
            showNormalized: !this.state.showNormalized,
        });
    }

    render() {
        const { from, until, showNormalized } = this.state;
        const { statisticsEmails } = this.props;

        let total = 0, failed = 0, sent = 0, sentManual = 0, spam = 0;

        let totalShipnext = 0, totalShipnextFailed = 0, totalShipnextSent = 0, 
            totalShipnextSpam = 0, totalShipnextSentManual = 0;

        let totalConnect = 0, totalConnectFailed = 0, totalConnectSent = 0, 
            totalConnectSpam = 0;

        let totalVaramar = 0, totalVaramarFailed = 0, totalVaramarSent = 0, 
            totalVaramarSpam = 0, totalVaramarSentManual = 0;

        let totalBroker = 0, totalBrokerFailed = 0, totalBrokerSent = 0, 
            totalBrokerSpam = 0, totalBrokerSentManual = 0;

        let shipnextCargo = 0, shipnextCargoFailed = 0, shipnextCargoSent = 0, 
            shipnextCargoSentManual = 0,
            shipnextVessel = 0, shipnextVesselFailed = 0, shipnextVesselSent = 0,
            shipnextVesselSentManual = 0;

        let connectCargo = 0, connectCargoFailed = 0, connectCargoSent = 0,
            connectVessel = 0, connectVesselFailed = 0, connectVesselSent = 0;

        let varamarCargo = 0, varamarCargoFailed = 0, varamarCargoSent = 0,
            varamarCargoSentManual = 0,
            varamarVessel = 0, varamarVesselFailed = 0, varamarVesselSent = 0,
            varamarVesselSentManual = 0;

        let brokerCargo = 0, brokerCargoFailed = 0, brokerCargoSent = 0,
            brokerCargoSentManual = 0,
            brokerVessel = 0, brokerVesselFailed = 0, brokerVesselSent = 0,
            brokerVesselSentManual = 0;
    
        const stats = {};

        statisticsEmails.forEach((item) => {
            totalShipnext += item.shipnext.sent + item.shipnext.failed + item.shipnext.spam;
            totalShipnextFailed += item.shipnext.failed;
            totalShipnextSent += item.shipnext.sent;
            totalShipnextSentManual += item.shipnext.totalSentManual || 0;
            totalShipnextSpam += item.shipnext.spam;

            shipnextCargoFailed += item.shipnext.cargoFailed;
            shipnextCargoSent += item.shipnext.cargoSent;
            shipnextCargoSentManual += item.shipnext.sentManualCargo || 0;
            shipnextCargo += item.shipnext.cargoFailed + item.shipnext.cargoSent;

            shipnextVesselFailed += item.shipnext.vesselFailed;
            shipnextVesselSent += item.shipnext.vesselSent;
            shipnextVesselSentManual += item.shipnext.sentManualVessel || 0;
            shipnextVessel += item.shipnext.vesselFailed + item.shipnext.vesselSent;

            totalConnect += item.api.sent + item.api.failed + item.api.spam;
            totalConnectFailed += item.api.failed;
            totalConnectSent += item.api.sent;
            totalConnectSpam += item.api.spam;

            connectCargoFailed += item.api.cargoFailed;
            connectCargoSent += item.api.cargoSent;
            connectCargo += item.api.cargoFailed + item.api.cargoSent;

            connectVesselFailed += item.api.vesselFailed;
            connectVesselSent += item.api.vesselSent;
            connectVessel += item.api.vesselFailed + item.api.vesselSent;

            totalVaramar += item.varamar.sent + item.varamar.failed + item.varamar.spam;
            totalVaramarFailed += item.varamar.failed;
            totalVaramarSent += item.varamar.sent;
            totalVaramarSentManual += item.varamar.totalSentManual || 0;
            totalVaramarSpam += item.varamar.spam;

            varamarCargoFailed += item.varamar.cargoFailed;
            varamarCargoSent += item.varamar.cargoSent;
            varamarCargoSentManual += item.varamar.sentManualCargo || 0;
            varamarCargo += item.varamar.cargoFailed + item.varamar.cargoSent;

            varamarVesselFailed += item.varamar.vesselFailed;
            varamarVesselSent += item.varamar.vesselSent;
            varamarVesselSentManual += item.varamar.sentManualVessel || 0;
            varamarVessel += item.varamar.vesselFailed + item.varamar.vesselSent;

            totalBroker += item.broker.sent + item.broker.failed + item.broker.spam;
            totalBrokerFailed += item.broker.failed;
            totalBrokerSent += item.broker.sent;
            totalBrokerSentManual += item.broker.totalSentManual || 0;
            totalBrokerSpam += item.broker.spam;

            brokerCargoFailed += item.broker.cargoFailed;
            brokerCargoSent += item.broker.cargoSent;
            brokerCargoSentManual += item.broker.sentManualCargo || 0;
            brokerCargo += item.broker.cargoFailed + item.broker.cargoSent;

            brokerVesselFailed += item.broker.vesselFailed;
            brokerVesselSent += item.broker.vesselSent;
            brokerVesselSentManual += item.broker.sentManualVessel || 0;
            brokerVessel += item.broker.vesselFailed + item.broker.vesselSent;

            sent += item.varamar.sent + item.shipnext.sent + item.api.sent + item.broker.sent;
            failed += item.varamar.failed + item.shipnext.failed + item.api.failed + item.broker.failed;
            spam += item.varamar.spam + item.shipnext.spam + item.api.spam + item.broker.spam;
        });
        total += totalShipnext + totalConnect + totalVaramar + totalBroker;
        sentManual += totalShipnextSentManual + totalVaramarSentManual + totalBrokerSentManual;
        
        stats.cargoVessel = {
            // total
            allCargo: shipnextCargo + connectCargo + varamarCargo + brokerCargo,
            allVessel: shipnextVessel + connectVessel + varamarVessel + brokerVessel,
    
            allCargoSent: shipnextCargoSent + connectCargoSent + varamarCargoSent + brokerCargoSent,
            allCargoSentManual: shipnextCargoSentManual + varamarCargoSentManual + brokerCargoSentManual,
            allVesselSent: shipnextVesselSent + connectVesselSent + varamarVesselSent + brokerVesselSent,
            allVesselSentManual: shipnextVesselSentManual + varamarVesselSentManual + brokerVesselSentManual,
    
            allCargoFailed: shipnextCargoFailed + connectCargoFailed + varamarCargoFailed + brokerCargoFailed,
            allVesselFailed: shipnextVesselFailed + connectVesselFailed + varamarVesselFailed + brokerVesselFailed,
        };

        return (
            <div id='statistics-emails' className='container'>
                <h3>Statistics emails</h3>
                <Charts
                    showNormalized={showNormalized}
                />
                <RangeDates 
                    from={from} 
                    until={until} 
                    changeDateRange={this.changeDateRange} 
                    handleNormalize={this.handleNormalize}
                    checked={showNormalized}
                />
                <p>General statistics:</p>

                <div className="row">
                    <div className="col-xs-2-4">
                        <div className='paper-block'>
                            <div className='name-block absolute small-name'>All</div>
                            <p>Total - {total}</p>
                            <p>Spam - {`${spam} (${getPercentFixed(spam, total)}%)`}</p>
                            <p>Sent - {`${sent} (${getPercentFixed(sent, total)}%)`}</p>
                            <p>Sent (manual) - {`${sentManual} (${getPercentFixed(sentManual, total)}%)`}</p>
                            <p>Failed - {`${failed} (${getPercentFixed(failed, total)}%)`}</p>
                        </div>
                    </div>

                    <div className="col-xs-2-4">
                        <div className='paper-block'>
                            <div className='name-block absolute small-name'>Varamar</div>
                            <p>Total - {totalVaramar}</p>
                            <p>Spam - {`${totalVaramarSpam} (${getPercentFixed(totalVaramarSpam, totalVaramar)}%)`}</p>
                            <p>Sent - {`${totalVaramarSent} (${getPercentFixed(totalVaramarSent, totalVaramar)}%)`}</p>
                            <p>Sent (manual) - {`${totalVaramarSentManual} (${getPercentFixed(totalVaramarSentManual, totalVaramar)}%)`}</p>
                            <p>Failed - {`${totalVaramarFailed} (${getPercentFixed(totalVaramarFailed, totalVaramar)}%)`}</p>
                        </div>
                    </div>

                    <div className="col-xs-2-4">
                        <div className='paper-block'>
                            <div className='name-block absolute small-name'>Shipnext</div>
                            <p>Total - {totalShipnext}</p>
                            <p>Spam - {`${totalShipnextSpam} (${getPercentFixed(totalShipnextSpam, totalShipnext)}%)`}</p>
                            <p>Sent - {`${totalShipnextSent} (${getPercentFixed(totalShipnextSent, totalShipnext)}%)`}</p>
                            <p>Sent (manual) - {`${totalShipnextSentManual} (${getPercentFixed(totalShipnextSentManual, totalShipnext)}%)`}</p>
                            <p>Failed - {`${totalShipnextFailed} (${getPercentFixed(totalShipnextFailed, totalShipnext)}%)`}</p>
                        </div>
                    </div>

                    <div className="col-xs-2-4">
                        <div className='paper-block'>
                            <div className='name-block absolute small-name'>Connect</div>
                            <p>Total - {totalConnect}</p>
                            <p>Spam - {`${totalConnectSpam} (${getPercentFixed(totalConnectSpam, totalConnect)}%)`}</p>
                            <p>Sent - {`${totalConnectSent} (${getPercentFixed(totalConnectSent, totalConnect)}%)`}</p>
                            <p>Failed - {`${totalConnectFailed} (${getPercentFixed(totalConnectFailed, totalConnect)}%)`}</p>
                        </div>
                    </div>

                    <div className="col-xs-2-4">
                        <div className='paper-block'>
                            <div className='name-block absolute small-name'>Broker</div>
                            <p>Total - {totalBroker}</p>
                            <p>Spam - {`${totalBrokerSpam} (${getPercentFixed(totalBrokerSpam, totalBroker)}%)`}</p>
                            <p>Sent - {`${totalBrokerSent} (${getPercentFixed(totalBrokerSent, totalBroker)}%)`}</p>
                            <p>Sent (manual) - {`${totalBrokerSentManual} (${getPercentFixed(totalBrokerSentManual, totalBroker)}%)`}</p>
                            <p>Failed - {`${totalBrokerFailed} (${getPercentFixed(totalBrokerFailed, totalBroker)}%)`}</p>
                        </div>
                    </div>
                </div>

                <p>Cargo / Vessel statistics:</p>

                <div className="row">
                    <div className="col-xs-2-4">
                        <div className='paper-block'>
                            <div className='name-block absolute small-name'>All</div>
                            <p>Cargo/Vessel - {`${stats.cargoVessel.allCargo} / ${stats.cargoVessel.allVessel}`}</p>
                            <p>Sent - {`${stats.cargoVessel.allCargoSent} / ${stats.cargoVessel.allVesselSent}`}</p>
                            <p>Sent (manual) - {`${stats.cargoVessel.allCargoSentManual} / ${stats.cargoVessel.allVesselSentManual}`}</p>
                            <p>Failed - {`${stats.cargoVessel.allCargoFailed} / ${stats.cargoVessel.allVesselFailed}`}</p>
                        </div>
                    </div>

                    <div className="col-xs-2-4">
                        <div className='paper-block'>
                            <div className='name-block absolute small-name'>Varamar</div>
                            <p>Cargo/Vessel - {`${varamarCargo} / ${varamarVessel}`}</p>
                            <p>Sent - {`${varamarCargoSent} / ${varamarVesselSent}`}</p>
                            <p>Sent (manual) - {`${varamarCargoSentManual} / ${varamarVesselSentManual}`}</p>
                            <p>Failed - {`${varamarCargoFailed} / ${varamarVesselFailed}`}</p>
                        </div>
                    </div>

                    <div className="col-xs-2-4">
                        <div className='paper-block'>
                            <div className='name-block absolute small-name'>Shipnext</div>
                            <p>Cargo/Vessel - {`${shipnextCargo} / ${shipnextVessel}`}</p>
                            <p>Sent - {`${shipnextCargoSent} / ${shipnextVesselSent}`}</p>
                            <p>Sent (manual) - {`${shipnextCargoSentManual} / ${shipnextVesselSentManual}`}</p>
                            <p>Failed - {`${shipnextCargoFailed} / ${shipnextVesselFailed}`}</p>
                        </div>
                    </div>

                    <div className="col-xs-2-4">
                        <div className='paper-block'>
                            <div className='name-block absolute small-name'>Connect</div>
                            <p>Cargo/Vessel - {`${connectCargo} / ${connectVessel}`}</p>
                            <p>Sent - {`${connectCargoSent} / ${connectVesselSent}`}</p>
                            <p>Failed - {`${connectCargoFailed} / ${connectVesselFailed}`}</p>
                        </div>
                    </div>

                    <div className="col-xs-2-4">
                        <div className='paper-block'>
                            <div className='name-block absolute small-name'>Broker</div>
                            <p>Cargo/Vessel - {`${brokerCargo} / ${brokerVessel}`}</p>
                            <p>Sent - {`${brokerCargoSent} / ${brokerVesselSent}`}</p>
                            <p>Sent (manual) - {`${brokerCargoSentManual} / ${brokerVesselSentManual}`}</p>
                            <p>Failed - {`${brokerCargoFailed} / ${brokerVesselFailed}`}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        isLogged: state.user.isLogged,
        statisticsEmails: state.statisticsEmails.items,
    }),
    dispatch => bindActionCreators(
        {
            getStatisticsEmails,
        },
        dispatch,
    ),
)(StatisticsEmailsPage);



// WEBPACK FOOTER //
// ./app/components/Statistics/Emails/Page.jsx